import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { downloadDoc } from '../../../../../common/services/http/documentsService';
import LoadingCell from '../../../../ui/table/cells/loadingCell/loadingCell';
import { useInternationalization } from '@progress/kendo-react-intl';

import './mobileNameCell.scss';
import Icon from '../../../../ui/icon/icon';

const MobileNameCell = (props) => {
  const [isRead, setIsRead] = useState(props.dataItem.isRead);
  let navigate = useNavigate();

  const intl = useInternationalization();
  const linkToOrigin = props.origin === 'homePage' ? 'documents/pdf' : 'pdf';
  const docId = props.dataItem[props.idField || 'id'];

  const navigateToBoard = (investorId: number, boardId: number): void => {
    navigate(`/boards/${investorId}/${boardId}`);
  };

  if (props.dataItem[props.field] === undefined) return <LoadingCell />;

  const updateIsReadFlag = (isRead) => {
    setIsRead(isRead);
    props.dataItem.isRead = isRead;
  };

  useEffect(() => {
    setIsRead(props.dataItem.isRead);
  }, [isRead]);

  return props.dataItem.type === 'board' ? (
    <td className='mobile-name-cell' style={{ width: props.width }}>
      <div className='mobile-name-wrapper'>
        <Icon name='fal fa-tachometer-alt-average' className='document-icon' />
        <div className="mobile-name-cell">
          <span onClick={() => navigateToBoard(props.dataItem.objectId, props.dataItem.contentId)}>{props.dataItem[props.field]}</span>
          <div className='date-info'>{intl.formatDate(new Date(props.dataItem['publishDate']), 'd')}</div>
        </div>
      </div>
    </td>
  ) : (
    <td className='mobile-name-cell' style={{ width: props.width }}>
      <div className='mobile-name-wrapper'>
        <Icon name='fal fa-file-chart-line' className='document-icon' />
        {props.dataItem.fileType && props.dataItem.fileType.toLowerCase() === 'pdf' ? (
          <Link to={`${linkToOrigin}/${docId}`} className='mobile-name-cell'>
              <span
                style={{ fontWeight: !isRead ? 'bold' : 'normal' }}
                onClick={() => {
                  updateIsReadFlag(true);
                }}>
                {props.dataItem[props.field]}
              </span>
            <div className='date-info'>{intl.formatDate(new Date(props.dataItem['publishDate']), 'd')}</div>
          </Link>
        ) : (
          <div className='mobile-name-cell'>
              <span style={{ fontWeight: !isRead ? 'bold' : 'normal' }} onClick={() => downloadDoc(props.dataItem)}>
                {props.dataItem[props.field]}
              </span>
              <div className='date-info'>{intl.formatDate(new Date(props.dataItem['publishDate']), 'd')}</div>
          </div>
        )}
      </div>
    </td>
  );
};

export default MobileNameCell;
